import { ALL_BUSINESS_UNIT_ID, DEFAULT_BUSINESS_UNIT_ID, SELECTED_BUSINESS_UNIT_LOCAL_STORAGE_KEY } from '../constants/BusinessUnits';
import { queryLocalStorage, removeLocalStorage, setLocalStorage } from './localstorage';
export const isDefaultBusinessUnit = businessUnit => {
  return businessUnit.id === DEFAULT_BUSINESS_UNIT_ID;
};
export const isAllBusinessUnit = businessUnit => {
  return businessUnit.id === ALL_BUSINESS_UNIT_ID;
};
export const isCustomBusinessUnit = unit => !isAllBusinessUnit(unit) && !isDefaultBusinessUnit(unit);
export const hasCustomBusinessUnits = businessUnits => businessUnits.some(isCustomBusinessUnit);
export const getBusinessUnitLocalStorage = () => queryLocalStorage(SELECTED_BUSINESS_UNIT_LOCAL_STORAGE_KEY) || {};
export function setLocalStorageBusinessUnitId({
  portalId,
  businessUnit
}) {
  const localStorageBusinessUnit = getBusinessUnitLocalStorage();
  localStorageBusinessUnit[portalId] = businessUnit.id;
  setLocalStorage(SELECTED_BUSINESS_UNIT_LOCAL_STORAGE_KEY, localStorageBusinessUnit);
}
export const resetBusinessUnitsLocalStorageIfNeeded = ({
  scopes
}) => {
  const businessUnitScopeIncluded = scopes.includes('business-units-access');
  const businessUnitsLS = queryLocalStorage(SELECTED_BUSINESS_UNIT_LOCAL_STORAGE_KEY);
  if (!businessUnitScopeIncluded && businessUnitsLS) {
    removeLocalStorage(SELECTED_BUSINESS_UNIT_LOCAL_STORAGE_KEY);
  }
};